import logo from './LogoPP.png';
import './App.css';

function App() {
  return (
    <div className="App">
{/*       <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header> */}
      <body>
      <h3>BASES LEGALES DEL SORTEO DE 2 ENTRADAS PARA EL SHOW DE GEORGE HARRIS "HIJO ÚNICO" EN MADRID</h3>
      <h4>1. ORGANIZADOR DEL SORTEO</h4>
      <p>Placer Producciones, en adelante denominado "el Organizador," organiza un sorteo en la plataforma Instagram para regalar 2 entradas para el espectáculo de George Harris "Hijo Único" en Madrid el día 29 de Octubre.</p>

<h4>2. REQUISITOS PARA PARTICIPAR</h4>

<p>Para participar en el sorteo, los participantes deben cumplir con los siguientes requisitos:

Seguir la cuenta de Instagram @placerproducciones.
Escribir un comentario en la publicación del sorteo nombrando a 3 amigos.
Dar like a la publicación del sorteo.
</p>
<h4>3. FECHAS DE PARTICIPACIÓN</h4>

<p>La participación en el sorteo estará abierta desde el momento en que se publique la publicación del sorteo en la cuenta de Instagram de @placerproducciones hasta el día 29 de septiembre a las 20:00hs (hora local de Madrid). Cualquier participación realizada después de esta fecha y hora no será válida.</p>

<h4>4. SELECCIÓN DEL GANADOR</h4>

El ganador será seleccionado al azar entre todos los participantes que cumplan con los requisitos mencionados en el punto 2. El sorteo se realizará de manera imparcial y objetiva.

<h4>5. ANUNCIO DEL GANADOR</h4>

El resultado del sorteo se publicará en las redes sociales de @placerproducciones el día 29 de septiembre a las 22:00hs (hora local de Madrid). El ganador será contactado a través de un mensaje privado en Instagram para coordinar la entrega de las entradas.

<h4>6. PREMIOS</h4>

El premio consiste en 2 entradas para el show de George Harris "Hijo Único" en El Palacio de Vista Alegre de Madrid el día 29 de Octubre. El premio no es transferible ni canjeable por dinero u otros bienes.

<h4>7. ACEPTACIÓN DE LAS BASES</h4>

La participación en este sorteo implica la aceptación de estas bases legales en su totalidad. Cualquier incumplimiento de estas bases resultará en la descalificación del participante.

<h4>8. RESPONSABILIDAD</h4>

El Organizador no asume responsabilidad alguna por problemas técnicos, errores humanos o cualquier otra circunstancia que pueda afectar el desarrollo normal del sorteo.

<h4>9. MODIFICACIÓN O CANCELACIÓN</h4>

El Organizador se reserva el derecho de modificar o cancelar el sorteo en caso de circunstancias imprevistas que lo hagan necesario, sin que los participantes tengan derecho a reclamación alguna.

<h4>10. LEGISLACIÓN APLICABLE</h4>

Este sorteo se rige por la legislación española vigente.

<h4>11. CONTACTO</h4>

Cualquier consulta o duda relacionada con este sorteo puede ser dirigida a la cuenta de Instagram @placerproducciones o a través del correo electrónico contacto@placerproducciones.com.

Madrid, a 26 de Septiembre de 2023.
      </body>
    </div>
  );
}

export default App;
